import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Card, Spin, Typography } from 'antd';
import { apiClient } from '@shared/api/client';
import { useAuthStore, AuthUser } from '@shared/hooks/useAuthStore';
import { canAccessBackoffice, NO_BO_ACCESS_MSG } from '@shared/utils/roleAccess';

interface AdminSession { token: string; user: AuthUser; expiresAt: string }

/** Atterraggio del link generato da admin-login.sh (spec §2). */
export function TokenLoginPage(): React.ReactElement {
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  const once = useRef(false);

  useEffect(() => {
    if (once.current) return; // StrictMode: un solo exchange (il token è monouso)
    once.current = true;
    const token = new URLSearchParams(window.location.hash.slice(1)).get('t');
    // Il token esce subito dalla barra indirizzi/cronologia.
    window.history.replaceState(null, '', window.location.pathname);
    if (!token) { setErr('Link incompleto: rigeneralo con admin-login.sh sulla EC2.'); return; }
    apiClient
      .post<AdminSession>('/auth/admin-token/exchange', { token })
      .then(({ data }) => {
        // BO-18: oggi lo scambio restituisce sempre SUPER_ADMIN, ma non ci si fida.
        if (!canAccessBackoffice(data.user?.role)) {
          useAuthStore.getState().logout();
          setErr(NO_BO_ACCESS_MSG);
          return;
        }
        useAuthStore.getState().setAuth(data.token, data.user, 'admin-token');
        nav('/setup', { replace: true });
      })
      .catch(() => setErr('Link non valido, scaduto o già usato: rigeneralo con admin-login.sh sulla EC2.'));
  }, [nav]);

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <Card style={{ width: 420 }}>
        <Typography.Title level={4}>Accesso amministratore</Typography.Title>
        {err ? <Alert type="error" message={err} showIcon /> : <Spin />}
      </Card>
    </div>
  );
}
